import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedHTMLMessage } from 'react-intl'

import { SendRPCompletion } from 'containers/forms/dashboard'
import { ObservationOverview } from 'components/sections/dashboard'
import { CircleBadge, CenteredContent, Note } from 'components/misc'
import { ACTIVITY_STATES } from 'constants/enums'
import { apiDashboard } from 'helpers/decorators/api'
import { modal } from 'helpers/decorators'
import {
  DashboardGrid as Grid,
  ElevatedButton,
  MaterialControlBar
} from 'components/layout'
import MODALS from 'constants/layout/modals'

@apiDashboard.apiResidentialProject({
  loaders: ['completion', 'detail'],
  loadDetail: true
})
@modal.trigger()
@connect(({ api }) => ({
  isFileUploading: api.blob.loading
}))
class RPReport extends Component {
  static propTypes = {
    onOpenAssessorApproval: PropTypes.func,
    onOpen: PropTypes.func,
    onCompletionRP: PropTypes.func,
    residentialProject: PropTypes.object,
    completionStatus: PropTypes.object,
    colorClass: PropTypes.string,
    detailStatus: PropTypes.object,
    isFileUploading: PropTypes.bool
  }

  state = {
    isEditing: false
  }

  handleCompletionRP = (...params) =>
    this.props
      .onCompletionRP(...params)
      .then(this.handleCancelEdit)
      .then(this.props.onOpenAssessorApproval)

  handleStartEditObservation = () => this.setState({ isEditing: true })
  handleCancelEdit = () => this.setState({ isEditing: false })

  openSendForApprovalModal = () =>
    this.props.onOpen(MODALS.SEND_RP_ASSESSOR_APPROVAL)

  render() {
    const {
      residentialProject,
      detailStatus,
      completionStatus,
      colorClass,
      isFileUploading
    } = this.props
    const { isEditing } = this.state

    const isAssessmentPositive = get(residentialProject, 'isAssessmentPositive')
    const state = get(residentialProject, 'state.value')
    const id = get(residentialProject, 'id')
    const observations = get(residentialProject, 'observations')
    const fileUrls = get(detailStatus, 'fileUrls', [])

    return (
      <Grid.RightInner white={ACTIVITY_STATES.in_progress.id === state}>
        {ACTIVITY_STATES.waiting_for_approval.id === state && (
          <CenteredContent
            flex
            textAlign
            style={{ marginTop: '150px', flexDirection: 'column' }}
          >
            <CircleBadge colorClass={colorClass} large medal padded>
              <i className="ico ico--timer" />
            </CircleBadge>
            <Note margin="25px 0 0 0">
              <FormattedHTMLMessage
                id="label.your_residential_project_has_been_setup"
                defaultMessage="Your Residential Project has been setup and sent to your Award Leader. <br /> Now we wait for his/her Approval."
              />
            </Note>
          </CenteredContent>
        )}
        {ACTIVITY_STATES.assessment.id === state && (
          <div>
            {!isAssessmentPositive && (
              <CenteredContent
                flex
                textAlign
                style={{ marginTop: '150px', flexDirection: 'column' }}
              >
                <CircleBadge colorClass={colorClass} large medal padded>
                  <i className="ico ico--timer" />
                </CircleBadge>
                <Note margin="25px 0 0 0">
                  <FormattedHTMLMessage
                    id="label.your_report_has_been_sent_assessor"
                    defaultMessage="Your Report has been sent to the Assessor. <br /> Now we wait for his/her Approval."
                  />
                </Note>
              </CenteredContent>
            )}
            {isAssessmentPositive &&
              (observations && (
                <div className="col-xs-12">
                  <ObservationOverview
                    colorClass={colorClass}
                    observations={observations}
                    fileUrls={fileUrls}
                    readOnly
                  />
                </div>
              ))}
          </div>
        )}

        {ACTIVITY_STATES.award_leader_singoff.id === state && (
          <CenteredContent
            flex
            textAlign
            style={{ marginTop: '150px', flexDirection: 'column' }}
          >
            <CircleBadge colorClass={colorClass} large medal padded>
              <i className="ico ico--timer" />
            </CircleBadge>
            <Note margin="25px 0 0 0">
              <FormattedHTMLMessage
                id="label.your_report_has_been_sent_leader"
                defaultMessage="Your Report has been sent to your Award Leader."
              />
            </Note>
          </CenteredContent>
        )}
        {ACTIVITY_STATES.in_progress.id === state && (
          <div className="row">
            {observations &&
              !isEditing && (
                <div className="col-xs-12">
                  <ObservationOverview
                    header={
                      <div>
                        <MaterialControlBar
                          edit={{
                            onClick: this.handleStartEditObservation,
                            intlKey: 'button.edit_observation',
                            label: 'Edit Observation'
                          }}
                        />
                        <Note intlKey="label.you_can_send_residential_project_to_leader">
                          You can now send your Residential Project to your
                          Award Leader for approval.
                        </Note>
                        <ElevatedButton
                          colorClass={colorClass}
                          onClick={this.openSendForApprovalModal}
                          intlKey="button.send_for_approval"
                        >
                          Send for approval
                        </ElevatedButton>
                      </div>
                    }
                    colorClass={colorClass}
                    observations={observations}
                    fileUrls={fileUrls}
                  />
                </div>
              )}

            {(isEditing || !observations) && (
              <div className="col-xs-6">
                <SendRPCompletion
                  id={id}
                  loading={get(completionStatus, 'loading')}
                  colorClass={colorClass}
                  onSubmit={this.handleCompletionRP}
                  submitDisabled={isFileUploading}
                  initialValues={isEditing ? { observations, fileUrls } : null}
                  isEditing={isEditing}
                  onCancel={this.handleCancelEdit}
                />
              </div>
            )}
          </div>
        )}
        {[
          ACTIVITY_STATES.complete.id,
          ACTIVITY_STATES.ceremony.id,
          ACTIVITY_STATES.office_signoff.id
        ].includes(state) && (
          <CenteredContent
            flex
            textAlign
            style={{ marginTop: '150px', flexDirection: 'column' }}
          >
            <CircleBadge colorClass={colorClass} large medal>
              <i className="ico ico--icon-victory" />
            </CircleBadge>
            <Note margin="25px 0 0 0">
              <FormattedHTMLMessage
                id="label.your_residential_project_is_complete"
                defaultMessage="Your Residential Project is complete."
              />
            </Note>
          </CenteredContent>
        )}
      </Grid.RightInner>
    )
  }
}

export default RPReport
